export default __webpack_public_path__ + "static/media/EconoMetrics.795322ec.gif";